module.exports = __webpack_public_path__ + "static/img/r-3.16fd3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-3.jpg
// module id = Ktbe
// module chunks = 0